import { render, staticRenderFns } from "./EspecialesSanciones.vue?vue&type=template&id=683f47b2&"
import script from "./EspecialesSanciones.vue?vue&type=script&lang=js&"
export * from "./EspecialesSanciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports